import { render } from "./protocol_description.vue?vue&type=template&id=227858e8"
import script from "./protocol_description.vue?vue&type=script&lang=js"
export * from "./protocol_description.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/create/tabs/protocol_description.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "227858e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('227858e8', __exports__)) {
    console.log('reload')
    api.reload('227858e8', __exports__)
  }
  
  module.hot.accept("./protocol_description.vue?vue&type=template&id=227858e8", () => {
    console.log('re-render')
    api.rerender('227858e8', render)
  })

}


export default __exports__